import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

interface LibraryStore {
  name: string
  setName: (name: string) => void
  id: string
  setId: (id: string) => void
  imageCount: number
  setImageCount: (imageCount: number) => void
}

export const useLibraryStore = create<LibraryStore>()(
  persist(
    (set) => ({
      name: '',
      setName: (name) => set({ name }),
      id: '',
      setId: (id) => set({ id }),
      imageCount: 0,
      setImageCount: (imageCount) => set({ imageCount }),
    }),
    {
      name: 'raster-library',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
)
